import AIPage from "./";

export default {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: "/ai",
      component: AIPage
    }
  ]
};



// WEBPACK FOOTER //
// ./src/main/content/project/ai/aiConfig.js